import { createIcon } from '@chakra-ui/react'

export const Documentation = createIcon({
  displayName: 'Documentation',
  viewBox: '0 0 22 20',
  d:
    'M21.47 5.2C21 4.96 20.51 4.76 20 4.59V16.62C18.86 16.21 17.69 16 16.5 16C14.6 16 12.72 16.54 11 17.58V5.48C9.38 4.55 7.51 4 5.5 4C3.71 4 2.02 4.44 0.53 5.2C0.2 5.36 0 5.71 0 6.08V18.16C0 18.74 0.47 19.15 1 19.15C1.16 19.15 1.32 19.11 1.48 19.03C2.69 18.4 4.05 18 5.5 18C7.57 18 9.48 18.82 11 20C12.52 18.82 14.43 18 16.5 18C17.95 18 19.31 18.4 20.52 19.04C20.68 19.12 20.84 19.16 21 19.16C21.52 19.16 22 18.75 22 18.17V6.08C22 5.71 21.8 5.36 21.47 5.2ZM9 16.62C7.86 16.21 6.69 16 5.5 16C4.31 16 3.14 16.21 2 16.62V6.71C3.11 6.24 4.28 6 5.5 6C6.7 6 7.89 6.25 9 6.72V16.62ZM18 0.5L13 5.5V15L18 10.5V0.5Z',
})
